module.exports = __webpack_public_path__ + "img/chat_system.2c4eea56.png";